/* Keeps product-page shipping-incentive lines in step with the cart.
   After every add/change the theme re-renders the side cart (#cart) from the
   "side-cart" section, which already contains a freshly rendered
   [data-shipping-incentive] line. We copy that markup instead of requesting
   the cart again. */
(function () {
	if (window.shippingIncentiveSync) return;
	window.shippingIncentiveSync = true;

	var sideCart = document.getElementById('cart');
	if (!sideCart || !document.querySelector('[data-shipping-incentive-sync]')) return;

	new MutationObserver(function () {
		var fresh = sideCart.querySelector('[data-shipping-incentive]');
		if (!fresh) return;
		document.querySelectorAll('[data-shipping-incentive-sync]').forEach(function (el) {
			if (el.innerHTML !== fresh.innerHTML) el.innerHTML = fresh.innerHTML;
		});
	}).observe(sideCart, { childList: true });
})();
